module.exports = __webpack_public_path__ + "img/fashion_placeholder.5c9f7981.jpg";